

























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import genericStation from '@/assets/station.svg';
import { MelosStation } from '@/services/api.service';

@Component
export default class MelosCarousel extends Vue {
  @Prop() private selectedItem!: number;
  @Prop() private itemList!: any;
  @Prop() private active!: boolean;
  @Prop() private showingCover!: boolean;

  private windowObj: any = window as any;

  // Melos carousel will not emit any 'selectedItemChanged' event until first selectedItem has been scrolled to
  private ready: boolean = false;

  private availableHeight: number = this.windowObj.innerHeight;
  private maxItemHeight: number = 100;
  private itemHeight: number = 100;
  private centralIndicatorOffset: number = 0;
  private itemImageSize: number = 0;
  private realItemImageSize: number = 0;
  private cellPadding: number = 0;

  private scrollEventHandler: any;
  private debouncedScroll: any;
  private topSnapOffset: number = 0;

  private scrolling: boolean = false;
  private scrollEventHandlerLock: boolean = false;
  private onAutoScroll: boolean = false;

  private mounted() {
    this.availableHeight = this.getAvailableHeight();
    this.itemHeight = this.getItemHeight();
    this.itemImageSize = this.getItemImageSize();
    this.realItemImageSize = this.getRealItemImageSize();
    this.cellPadding = this.getCellPadding();
    const windowObj: any = window as any;
    windowObj.addEventListener('resize', this.onWindowSizeChange);
    this.debouncedScroll();
  }

  private created() {
    this.scrollEventHandler = _.debounce(this.handleScroll, 0);
    this.debouncedScroll = _.debounce(this.scrollToSelectedItem, 500);
  }

  private destroyed() {
    const windowObj: any = window as any;
    windowObj.removeEventListener('resize', this.onWindowSizeChange);
  }

  @Watch('showingCover')
  private onShowingCoverUpdate() {
    this.onWindowSizeChange();
  }

  @Watch('selectedItem')
  private selectedItemChanged() {
    this.debouncedScroll();
  }

  @Watch('itemList')
  private itemListChanged() {
    this.debouncedScroll();
  }

  private getStationImage(station: MelosStation) {
    if (this.token === undefined) {
      return `https://api.melos.info/api/0.1/station/public/${station._id}/logo?t=${this.$store.state.uriTime}`;
    }
    return `https://api.melos.info/api/0.1/station/${station._id}/logo?access_token=${this.token}&t=${this.$store.state.uriTime}`;
  }

  private getFallbackImage() {
    return genericStation;
  }

  private get token(): string {
    return this.$store.state.session?.token || '';
  }

  private onItemImageError(error: any) {
    error.target.src = this.getFallbackImage();
  }

  private selectItem(itemIndex: number, itemId: string) {
    const selectedItemIndex: number = this.itemList.findIndex((item: any) => {
      return item._id === itemId;
    });
    const carousel: any = this.$refs.carousel;
    carousel.scroll({
      top: this.getScrollOffsetForRealIndex(itemIndex),
      left: 0,
      behavior: 'smooth',
    });
  }

  private onScroll(event: any) {
    const data = [ ...event.target.classList ];
//    if (!data.includes('melos-carousel-snap')) {
//      // Ignore snap events
//      return;
//    }
    if (this.onAutoScroll) {
      // Ignore auto scroll events
      this.onAutoScroll = false;
      return;
    }
    if (this.scrollEventHandlerLock) {
      return;
    }
    this.scrolling = true;
    this.scrollEventHandler();
  }

  private get selectedItemId(): string {
    if (this.selectedItem === undefined || !this.itemList || !this.itemList[this.selectedItem]) {
      return 'none';
    }
    return this.itemList[this.selectedItem]._id;
  }

  @Watch('playerInterfaceOffset')
  private onPlayerInterfaceOffsetChanged() {
    this.availableHeight = this.getAvailableHeight();
  }

  private get playerInterfaceOffset(): number {
    return this.$store.state.interfaceData.showLargeInterface ? 70 : 0;
  }

  private isMobile() {
    const navigatorObj: any = navigator as any;
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigatorObj.userAgent);
  }

  private onWindowSizeChange() {
    this.availableHeight = this.getAvailableHeight();
    this.itemHeight = this.getItemHeight();
    this.itemImageSize = this.getItemImageSize();
    this.realItemImageSize = this.getRealItemImageSize();
    this.cellPadding = this.getCellPadding();
    this.ready = false;
    this.scrollToSelectedItem();
  }

  private getCentralIndicatorOffset() {
    return (this.itemList.length + 1) * this.itemHeight -
    this.topSnapOffset + this.itemHeight * this.selectedItem -
    1.5 * this.cellPadding - (this.itemHeight / 2 - this.realItemImageSize / 2) + this.realItemImageSize / 2;
  }

  private getAvailableHeight() {
    const windowObj: any = window as any;
    const documentObj: any = document as any;
    const viewportHeight = windowObj.innerHeight;
    // Chrome changes viewport when addressbar collapses due to vertical scrolling
    const realViweportHeight = Math.min(
      documentObj.documentElement.clientHeight,
      windowObj.screen.height,
      windowObj.innerHeight,
    );
    const carouselHeight = viewportHeight - this.getTopOffset() - 110 - this.playerInterfaceOffset;
    return carouselHeight;
  }

  private getTopSnapOffset() {
    const carousel: any = this.$refs.carousel;
    return carousel.scrollTop;
  }

  private getItemImageSize() {
    return Math.round(this.itemHeight / 1.5);
  }

  private getRealItemImageSize() {
    // Border = 6;
    // Padding = 10 (x2)
    return this.itemImageSize;
  }

  private getCellPadding() {
    // 18 = label height
    return (this.itemHeight - this.realItemImageSize - 18) / 2;
  }

  private get visibleItems(): number {
    return Math.round(this.availableHeight / this.itemHeight);
  }

  private get itemArray() {
    if (this.itemList.length === 0) {
      return [];
    }
    let array = this.itemList;
    while (array.length < 4 * (Math.max(this.visibleItems, this.itemList.length))) {
      array = array.concat(this.itemList);
    }
    return array;
  }

  private getTopOffset() {
    const carousel: any = this.$refs.carousel;
    if (!carousel) {
      return 0;
    }
    return carousel.getBoundingClientRect().top;
  }

  private getScrollOffsetForRealIndex(index: number) {
    return index * this.itemHeight - ((this.visibleItems - 1) / 2 * this.itemHeight);
  }

  private getScrollOffsetForIndex(index: number) {
    return (this.itemList.length - (this.visibleItems - 1) / 2 + index) * this.itemHeight;
  }

  private scrollToSelectedItem() {
    this.onAutoScroll = true;
    const carousel: any = this.$refs.carousel;
    if (!carousel) {
      return;
    }
    carousel.scrollTop = this.getScrollOffsetForIndex(this.selectedItem);
    this.topSnapOffset = this.getTopSnapOffset();
    if (!this.ready) {
      setTimeout(() => {
        this.ready = true;
        this.centralIndicatorOffset = this.getCentralIndicatorOffset();
      }, 500);
    }
  }

  private getItemHeight(): number {
    return Math.max(this.maxItemHeight, Math.round(this.availableHeight / 10));
  }

  private getSelectedItem(): number {
    const carousel: any = this.$refs.carousel;
    let item = Math.round(carousel.scrollTop / this.itemHeight - this.itemList.length + (this.visibleItems - 1) / 2);
    if (item >= this.itemList.length) {
      item = item % this.itemList.length;
    }
    while (item < 0) {
      item += this.itemList.length;
    }
    return item;
  }

  private handleScroll() {
    if (!this.ready) {
      return;
    }
//    this.scrollEventHandlerLock = true;
    const selectedItem: number = this.getSelectedItem();
    if (selectedItem !== this.selectedItem) {
      this.$emit('selectedItemChanged', selectedItem);
    } else {
      // Scroll to selected event to prevent scrolling issues when selected item does not change but scroll offset does
      this.debouncedScroll();
    }
    this.scrollEventHandlerLock = false;
    this.scrolling = false;
  }
}
